export function setProtagonistsHome(state, posts) {
    state.carousel = posts;
  }